import { Skeleton, Table } from "@/shared/ui";

const DAYS_COUNT = 31;
const EMPLOYEES_COUNT = 5;
const STAT_COLUMNS_COUNT = 5;

export default function TimesheetTableSkeleton() {
  return (
    <div className="w-full min-w-0 relative">
      <div className="overflow-x-auto overflow-y-hidden page-scroll pb-2">
        <Table.Table rounded={false}>
          <Table.Header variant="plain">
            <Table.Row className="border-none">
              <Table.HeadCell sticky className="whitespace-nowrap">
                <div className="flex items-center gap-1">
                  <Skeleton width={80} height={14} />
                  <Skeleton width={12} height={12} />
                </div>
              </Table.HeadCell>
              {Array.from({ length: DAYS_COUNT }).map(function renderDayHeadSkeleton(_, i) {
                return (
                  <Table.HeadCell key={i} width="w-10" align="center" className="p-2!">
                    <div className="flex flex-col gap-1">
                      <Skeleton width={16} height={14} />
                      <Skeleton width={16} height={10} />
                    </div>
                  </Table.HeadCell>
                );
              })}
              {Array.from({ length: STAT_COLUMNS_COUNT }).map(function renderStatHeadSkeleton(_, i) {
                return (
                  <Table.HeadCell key={`stat-${i}`} align="center" className="whitespace-nowrap">
                    <Skeleton width={50} height={14} />
                  </Table.HeadCell>
                );
              })}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {Array.from({ length: EMPLOYEES_COUNT }).map(function renderRowSkeleton(_, rowIndex) {
              return (
                <Table.Row key={rowIndex} className="border-none">
                  <Table.Cell sticky className="whitespace-nowrap">
                    <div className="flex items-center gap-2">
                      <Skeleton width={32} height={32} borderRadius="50%" />
                      <Skeleton width={120} height={14} />
                    </div>
                  </Table.Cell>
                  {Array.from({ length: DAYS_COUNT }).map(function renderDayCellSkeleton(_, dayIndex) {
                    return (
                      <Table.Cell key={dayIndex} width="w-10" align="center" className="p-2!">
                        <Skeleton width={40} height={40} borderRadius={4} />
                      </Table.Cell>
                    );
                  })}
                  {Array.from({ length: STAT_COLUMNS_COUNT }).map(function renderStatCellSkeleton(_, i) {
                    return (
                      <Table.Cell key={`stat-${i}`} align="center">
                        <Skeleton width={24} height={14} />
                      </Table.Cell>
                    );
                  })}
                </Table.Row>
              );
            })}
            <Table.Row className="border-none bg-surface-base-stroke/50">
              <Table.Cell sticky className="whitespace-nowrap">
                <Skeleton width={60} height={14} />
              </Table.Cell>
              {Array.from({ length: DAYS_COUNT }).map(function renderTotalDaySkeleton(_, i) {
                return (
                  <Table.Cell key={i} width="w-10" align="center" className="p-2!">
                    <div className="w-10 aspect-square" />
                  </Table.Cell>
                );
              })}
              {Array.from({ length: STAT_COLUMNS_COUNT }).map(function renderTotalStatSkeleton(_, i) {
                return (
                  <Table.Cell key={`stat-${i}`} align="center">
                    <Skeleton width={24} height={14} />
                  </Table.Cell>
                );
              })}
            </Table.Row>
          </Table.Body>
        </Table.Table>
      </div>
      <div className="flex items-center justify-between mt-4">
        <Skeleton width={200} height={16} />
        <div className="flex items-center gap-0">
          {Array.from({ length: 3 }).map(function renderPageBtnSkeleton(_, i) {
            return <Skeleton key={i} width={32} height={32} borderRadius={0} />;
          })}
        </div>
      </div>
    </div>
  );
}
